export default {
    acfMap() {
        function new_map($el) {
            // variables
            var $markers = $el.find('.marker');
            var args = {
                zoom: 16,
                center: new google.maps.LatLng(0, 0), // eslint-disable-line no-undef
                mapTypeId: google.maps.MapTypeId.ROADMAP, // eslint-disable-line no-undef
                mapId: '638febe49790e516',
            };

            // create map
            var map = new google.maps.Map($el[0], args); // eslint-disable-line no-undef

            // add a markers reference
            map.markers = [];

            // add markers
            $markers.each(function () {
                add_marker($(this), map); // eslint-disable-line no-undef
            });

            // center map
            center_map(map);

            // return
            return map;
        }

        function add_marker($marker, map) {
            // var
            var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng')); // eslint-disable-line no-undef

            // create marker
            var marker = new google.maps.Marker({ // eslint-disable-line no-undef
                position: latlng,
                icon: 'https://www.imagineworldwide.org/wp-content/uploads/marker.png',
                map: map,
            });

            // add to array
            map.markers.push(marker);

            // if marker contains HTML, add it to an infoWindow
            if ($marker.html()) {
                // create info window
                var infowindow = new google.maps.InfoWindow({ // eslint-disable-line no-undef
                    content: $marker.html(),
                });

                // show info window when marker is clicked
                google.maps.event.addListener(marker, 'click', function () { // eslint-disable-line no-undef
                    infowindow.open(map, marker);
                });
            }
        }

        function center_map(map) {
            // vars
            var bounds = new google.maps.LatLngBounds(); // eslint-disable-line no-undef

            // loop through all markers and create bounds
            $.each(map.markers, function (i, marker) {
                var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng()); // eslint-disable-line no-undef
                bounds.extend(latlng);
            });

            // only 1 marker?
            if (map.markers.length == 1) { // eslint-disable-line no-undef
                // set center of map
                map.setCenter(bounds.getCenter());
                map.setZoom(10);
            } else {
                // fit to bounds
                map.fitBounds(bounds);
            }
        }

        let map = null; // eslint-disable-line no-unused-vars
        $('.acf-map').each(function () {
            // create map
            map = new_map($(this));
        });
    },
    init() {
        // JavaScript to be fired on all pages

        // Advanced Custom Fields - Google Map output
        if ($('.acf-map').length > 0) {
            this.acfMap();
        }

        /** SKIP LINK NAVIGATION */
        $('#skip-to-content').click(function () {
            // strip the leading hash and declare
            // the content we're skipping to
            var skipTo = "#" + this.href.split('#')[1];
            // Setting 'tabindex' to -1 takes an element out of normal 
            // tab flow but allows it to be focused via javascript
            $(skipTo).attr('tabindex', -1).on('blur focusout', function () {
                // when focus leaves this element, 
                // remove the tabindex attribute
                $(this).removeAttr('tabindex');
            }).focus(); // focus on the content container
        });
        /** END SKIP LINK NAVIGATION */

        /** MASTHEAD PRGRESSIVE IMAGES **/
        var masthead = document.querySelector('.masthead'),
            placeholderOverlay = document.querySelector('.masthead__overlay');

        if (masthead && placeholderOverlay) {
            // Load full size image. When loaded, fade our placeholder add it as bg to masthead
            var img = new Image();
            img.src = masthead.dataset.imageSrc;
            img.onload = function () {
                placeholderOverlay.classList.add('fade-out');
                masthead.style.backgroundImage = "url(" + img.src + ")";
            };
        }
        /** END MASTHEAD PRGRESSIVE IMAGES **/

        // Reveal animation using waypoints
        function itemReveal() {
            var waypoints = $('.reveal').waypoint({ // eslint-disable-line no-unused-vars
                handler: function (direction) { // eslint-disable-line no-unused-vars
                    $(this)[0].classList.add('revealed');
                },
                offset: '85%',
            });

            var waypointChildren = $('.reveal--children > .wpb_wrapper > *').waypoint({ // eslint-disable-line no-unused-vars
                handler: function (direction) { // eslint-disable-line no-unused-vars
                    $(this)[0].element.classList.add('revealed');
                },
                offset: '85%',
            });
        }

        itemReveal();

        /** ANIMATED ANCHOR LINKS **/
        $('a[href*="#"]:not([href="#"])').click(function (e) {
            // Doesn't do it on page builder tabs
            if (!$(this).closest('li').hasClass('vc_tta-tab')) {
                if (!$(this).closest('h4').hasClass('vc_tta-panel-title')) {
                    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                        var target = $(this.hash);
                        var $this = this;
                        var header = $('header.header');
                        var wpAdminBar = $('#wpadminbar');
                        var fixedHeaderOffset = parseInt(header.outerHeight()) - parseInt(header.css("padding-top").replace("px", ""));
                        // If we're logged in and WP ADmin Bar exists, add it to the offset
                        if (wpAdminBar.length) {
                            fixedHeaderOffset += parseInt(wpAdminBar.outerHeight());
                        }
                        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            $('html,body').animate({
                                scrollTop: (target.offset().top - fixedHeaderOffset),
                            }, 500, function () {
                                if (history.pushState) {
                                    history.pushState(null, null, $this.hash);
                                }
                                else {
                                    location.hash = $this.hash;
                                }
                            });
                            e.preventDefault();
                        }
                    }
                }
            }
        });
        /** END ANIMATED ANCHOR LINKS **/

        /** Break link text to new line when link text is a URL **/
        $(document).ready(function () {

            $('a').each(function () {
                var $this = $(this);
                var innerLink = $this.text();
                if (innerLink.startsWith('http')) {
                    $this.css('word-break', 'break-all');
                }
            });
        });

        $('#mobile-nav a').click(function (event) {
            var a = $(this);
            var li = a.closest('li');

            if (li.hasClass('main-menu__item--parent')) {
                if (li.hasClass('mobile-nav--opened')) {
                    //second click, allow anchor click to continue normally
                }
                else {
                    //first click, prevent event, and open submenu
                    event.preventDefault();
                    li.addClass('mobile-nav--opened')
                }
            }
        });

        $('#nav-toggle').change(function () {
            $('.mobile-nav li').removeClass('mobile-nav--opened');
        })

        /** End Break link text to new line when link text is a URL **/

        // slick slide
        if ($('.visceral-slider').length > 0) {
            var slider = $('.visceral-slider > .wpb_column > .vc_column-inner > .wpb_wrapper');

            slider.slick({
                slide: '.visceral-slider > .wpb_column > .vc_column-inner > .wpb_wrapper > *',
                autoplay: true,
                autoplaySpeed: 7000,
                infinite: true,
                centerMode: true,
                centerPadding: '0px',
                cssEase: 'linear',
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
                dots: true,
                arrows: false,
                fade: true,
                mobileFirst: true,
                adaptiveHeight: false,
                pauseOnFocus: false,
                pauseOnHover: false,
                pauseOnDotsHover: false,
            });
        }

        // If a map (Work Site Map) was placed on the page, and it has attempted to load and failed,
        // reload map here. Occurs occaisionally... race condition maybe?
        if (window.map_data && window.map_data.missed) {
            window.visceral.map.init('.map');
        }

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js